var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForest1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 4.89157C22 6.48853 20.6913 7.78313 19.0771 7.78313C17.4628 7.78313 16.1541 6.48853 16.1541 4.89157C16.1541 3.2946 17.4628 2 19.0771 2C20.6913 2 22 3.2946 22 4.89157Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0771 8.98795C19.4806 8.98795 19.8078 9.3116 19.8078 9.71084V11.6386C19.8078 12.0378 19.4806 12.3614 19.0771 12.3614C18.6735 12.3614 18.3463 12.0378 18.3463 11.6386V9.71084C18.3463 9.3116 18.6735 8.98795 19.0771 8.98795Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.149 8.81059C16.4343 8.52828 16.4343 8.07057 16.149 7.78826C15.8636 7.50596 15.4009 7.50596 15.1156 7.78826L13.7377 9.15136C13.4523 9.43367 13.4523 9.89138 13.7377 10.1737C14.023 10.456 14.4857 10.456 14.7711 10.1737L16.149 8.81059Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9363 4.89157C14.9363 5.29081 14.6091 5.61446 14.2055 5.61446H12.2569C11.8533 5.61446 11.5262 5.29081 11.5262 4.89157C11.5262 4.49232 11.8533 4.16867 12.2569 4.16867H14.2055C14.6091 4.16867 14.9363 4.49232 14.9363 4.89157Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8078 19.2583C21.0685 18.9373 22 17.8052 22 16.4578C22 14.8609 20.6913 13.5663 19.0771 13.5663C17.4628 13.5663 16.1541 14.8609 16.1541 16.4578C16.1541 17.8052 17.0857 18.9373 18.3463 19.2583V21.2771C18.3463 21.6764 18.6735 22 19.0771 22C19.4806 22 19.8078 21.6764 19.8078 21.2771V19.2583Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08456 20.5355C1.78688 21.2322 2.31179 22 3.08576 22H13.9142C14.6929 22 15.2179 21.2236 14.9111 20.5257L13.3021 16.8646C12.9265 16.0098 11.6839 16.0098 11.3082 16.8646L10.7011 18.2459L7.8832 11.6509C7.51238 10.783 6.25161 10.783 5.88079 11.6509L2.08456 20.5355Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForest1);
export default __webpack_public_path__ + "static/media/forest-1.fe899f690e6e9f94cde1f93aed0dcbd1.svg";
export { ForwardRef as ReactComponent };